export const navItems = [
    { id: "recap", label: "Как это было" },
    { id: "program", label: "Программа" },
    { id: "tracks", label: "Треки" },
    { id: "speakers", label: "Спикеры" },
    { id: "partners", label: "Партнёры" },
    { id: "merch", label: "Мерч" },
    { id: "location", label: "Карта" },
] as const;

export const sectionFrame = "mx-auto w-full max-w-[1400px]";
export const headingLabel =
    "mb-6 text-[24px] leading-none font-normal tracking-[-0.04em] text-muted max-md:text-[18px] max-[639px]:mb-1 max-[639px]:text-[12px]";
export const headingTitle =
    "text-[52px] leading-none font-bold tracking-[-0.04em] uppercase max-md:text-[36px] max-[639px]:text-[20px] max-[639px]:leading-[1] max-[639px]:tracking-[-0.04em]";
